import React, { useEffect, useState } from "react";

import { useHistory, useParams } from "react-router-dom";
import { useAuthGlobal } from "../../../../../../contexts/auth-context/auth-context";

import { FilterModel } from "../../../../../../domain/models/enum";

import NotesList from "../../../../../../presentation/pages/developer/recurrency/notes";
import { settings } from "../../../../../configs/settings";

import { makeRemoteRecorrencyFiscalNote } from "../../../../usecases/fiscal-note/remote-fiscal-note-factory";
import { toastUtils } from "../../../../../../utils";
import { FiscalNoteResponseModel } from "../../../../../../domain/models/fiscal-note";

function MakeDocumentsList(): JSX.Element {
  const { profile, user } = useAuthGlobal();
  const { id } = useParams<{ id?: string }>();
  const [list, setList] = useState<FiscalNoteResponseModel>();
  const [params, setParams] = useState<FilterModel>({});
  const [loading, setLoading] = useState<boolean>();
  const [reload, setReload] = useState<boolean>(false);

  const history = useHistory();

  const loadData = async (idParam: number): Promise<void> => {
    try {
      setLoading(true);

      const data = await makeRemoteRecorrencyFiscalNote().loadNotesByIdRecurrency(idParam, {
        size: settings.perPage,
        sort: "id,desc",
        page: params?.page,
        query: params?.query,
      });
      setList(data);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const idParam = Number(id);
    if (!idParam) {
      toastUtils.showMessage({
        type: "warning",
        message: "Nota recorrente não encontrada!",
      });
      setTimeout(() => {
        history.push("/recurrency");
      }, 2000);
      return;
    };
    loadData(idParam);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, profile, user, reload, id]);

  const handleReload = (): void => {
    setReload((prev) => !prev);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      handleReload();
    }, 180000);
    return () => clearInterval(interval);
  }, []);

  return (
    <NotesList
      // params={params}
      list={list}
      setParams={setParams}
      loading={loading}
      handleReload={handleReload}
      isSuperAdmin={!!user?.roles?.find((r: any) => r.authority === "SUPERADMIN")}
    />
  );
}

export default MakeDocumentsList;
